import { useState } from 'react';
import { StartScreen } from './StartScreen';
import { startFinished } from './start-progress';

/**
 * The start screen's last step, «Preparazione del tuo spazio…» (#430), drawn by the shell over
 * itself. The shell mounts under it at once, so its reads run in parallel, and the screen stays
 * until every gate of the nav has answered (`useNavigationModel().settled`: the active context,
 * the operator profile, the administration scopes, the Finance capability and the clinical-study
 * permissions). Then the bar fills and the screen fades over a nav that is already complete.
 *
 * Only the first start of the page load is covered: a later reload of one of those reads (a
 * «Riprova», a change of organization) keeps the shell on screen.
 */
export function StartupOverlay({ settled }: { settled: boolean }) {
  const [finished, setFinished] = useState(startFinished);

  if (finished) {
    return null;
  }
  return settled ? (
    <StartScreen step={2} done onFinished={() => setFinished(true)} />
  ) : (
    <StartScreen step={2} />
  );
}
